import { MultiSelect } from "react-multi-select-component";
import { useState } from "react";

const CustomMultiSelectDropdown = ({
  name,
  values,
  options,
  disabled,
  handleChange,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(values);
  
  const handleOnChange = (values) => {
    setSelectedOptions(values);
    handleChange(values);
  };

  return (
      <MultiSelect
        options={options}
        value={selectedOptions}
        onChange={handleOnChange}
        labelledBy={name}
        className="form-control"
        disabled={disabled}
      />
  );
};
export default CustomMultiSelectDropdown;
